import { Component } from '@angular/core';
import { DialogService } from '../app.dialog-service';
import { TranslationService } from '../app.translation-service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.less']
})
export class FooterComponent {

	public footerExpanded = false;

	constructor(public i18n: TranslationService, public dialog: DialogService) {
	}

	/**
	 * Open Privacy dialog
	 */
	public openPrivacyDialog(): void {
		let privacyPolicyText = '';

		for (const line of this.i18n._.PRIVACY_POLICY_TEXT) {
			privacyPolicyText += '<p>' + line + '</p>';
		}

		this.dialog.openDialog(this.i18n._.PRIVACY_POLICY, privacyPolicyText);
	}

	/**
	 * Open Terms dialog
	 */
	public openTermsDialog(): void {
		this.dialog.openDialog(this.i18n._.TERMS, 'TODO');
	}

	/**
	 * Footer expanded
	 */
	public toggleFooter(): void {
		this.footerExpanded = !this.footerExpanded;
	}
}
